export enum MasterDataTypes {
    Master = "Master",
    Referential = "Referential",
}
